import React from 'react';
import { Table, TableColumnType, TableProps, SelectProps } from 'antd';
import { EditableCell, EditableRow } from './EditableCells';
import styles from '../styles/styles.module.scss';

type SelectOptions = SelectProps['options'];

export interface FeaturedTableColumnType<T> extends TableColumnType<T> {
  showSearch?: boolean;
  editable?: boolean;
  inputType?: string,
  editOptions?: SelectOptions;
}

interface FeaturedTableProps<T> extends TableProps<T> {
  columns: FeaturedTableColumnType<T>[];
  handleSave?: (row: T, changedValues: Partial<T>) => Promise<void>;
}

const FeaturedTable = <T,>({ columns, handleSave, ...props } : FeaturedTableProps<T>) => {
  const updatedColumns = (columns.map((col) => {
    if (!col.editable) {
      // return col;
      return {
        ...col,
      };
    }

    return {
      ...col,
      onCell: (record: any) => ({
        record,
        editable: col.editable,
        showSearch: col.showSearch,
        dataIndex: col.dataIndex,
        title: col.title,
        inputType: col.inputType,
        editOptions: col.editOptions,
        handleSave,
      }),
    };
  })) as TableColumnType<T>[];


  // useEffect(() => {
  //   setColumns(updatedColumns);
  // }, []);

  // setColumns(updatedColumns);


  const components = {
    body: {
      row: EditableRow,
      cell: EditableCell,
    },
  };

  return (
    <Table<T>
      columns={updatedColumns}
      components={components}
      rowClassName={ () => styles.editable_row }
      { ...props}
    />
  );
};

export default FeaturedTable;
